import { render, staticRenderFns } from "./BankLinkSuccess.vue?vue&type=template&id=3231bcc7&scoped=true&"
import script from "./BankLinkSuccess.vue?vue&type=script&lang=js&"
export * from "./BankLinkSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BankLinkSuccess.vue?vue&type=style&index=0&id=3231bcc7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3231bcc7",
  null
  
)

export default component.exports